import { render } from "./CoverageChanges.vue?vue&type=template&id=bd91cf24&scoped=true"
import script from "./CoverageChanges.vue?vue&type=script&lang=js"
export * from "./CoverageChanges.vue?vue&type=script&lang=js"

import "./CoverageChanges.vue?vue&type=style&index=0&id=bd91cf24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd91cf24"]])

export default __exports__